__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@linear-front-end/auth";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "2.2.3", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(658), __webpack_require__.e(875)]).then(() => (() => (__webpack_require__(96))))));
			register("axios", "1.6.8", () => (Promise.all([__webpack_require__.e(249), __webpack_require__.e(256)]).then(() => (() => (__webpack_require__(2249))))));
			register("i18next-browser-languagedetector", "7.2.0", () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(774))))));
			register("i18next-http-backend", "2.5.0", () => (__webpack_require__.e(804).then(() => (() => (__webpack_require__(4572))))));
			register("i18next", "23.10.0", () => (Promise.all([__webpack_require__.e(998), __webpack_require__.e(113)]).then(() => (() => (__webpack_require__(7998))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(393).then(() => (() => (__webpack_require__(6774))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(589).then(() => (() => (__webpack_require__(6113))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(484).then(() => (() => (__webpack_require__(7103))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(20), __webpack_require__.e(141)]).then(() => (() => (__webpack_require__(9316))))));
			register("react-i18next", "14.0.6", () => (Promise.all([__webpack_require__.e(20), __webpack_require__.e(791)]).then(() => (() => (__webpack_require__(9791))))));
			register("react-imask", "7.6.1", () => (Promise.all([__webpack_require__.e(485), __webpack_require__.e(20), __webpack_require__.e(388), __webpack_require__.e(494)]).then(() => (() => (__webpack_require__(4485))))));
			register("react-redux", "9.1.0", () => (Promise.all([__webpack_require__.e(20), __webpack_require__.e(863)]).then(() => (() => (__webpack_require__(6863))))));
			register("react-router-dom", "6.26.1", () => (Promise.all([__webpack_require__.e(155), __webpack_require__.e(20), __webpack_require__.e(746), __webpack_require__.e(397)]).then(() => (() => (__webpack_require__(4155))))));
			register("react-transition-group", "4.3.0", () => (Promise.all([__webpack_require__.e(152), __webpack_require__.e(20), __webpack_require__.e(388), __webpack_require__.e(746)]).then(() => (() => (__webpack_require__(4152))))));
			register("react", "18.3.1", () => (__webpack_require__.e(357).then(() => (() => (__webpack_require__(6357))))));
			register("redux-logger", "3.0.6", () => (__webpack_require__.e(611).then(() => (() => (__webpack_require__(7611))))));
			register("reselect", "5.1.1", () => (__webpack_require__.e(643).then(() => (() => (__webpack_require__(5643))))));
			register("scheduler", "0.23.2", () => (__webpack_require__.e(171).then(() => (() => (__webpack_require__(3171))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(103).then(() => (() => (__webpack_require__(103))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};